
export class Pescador {

  constructor(
    public nombre: string,
    public apellido: string,
    public ciudad: string,
    public estado: string,
    public tipolicencia: string,
    public costolicencia: number,
    public fechainiciopesca: Date,
    public idsolicitante?: string,
    public idregistro?: string,
    public cantidad?: number,
    public _id?: string,
    public deprecompra?: string,
    public licdevueltas?: number,
    public observaciones?: number,
    
    



  ) {}

}


// este modelo es para los pescadores
